<template>
	<div class="i-image-viewer" v-if="opened">
		<div class="fader" @click="exit" contenteditable="false">
			<div class="image-viewer-container" >
				<div class="exit-btn" @click="close()">
					<div class="fa fa-times"></div>
				</div>
				<div class="image-title">{{list[idx]&&list[idx].title&& (list[idx].title[lang]?list[idx].title[lang]:list[idx].title) || tr.untitled}} </div>
				<div class="image-box"  :style="{backgroundImage:`url(${loadedImage}?w=800)`}">
				<!-- <div class="image-box"  :style="{backgroundImage:`url(${list[idx].src}?w=800)`}"> -->
			       <table  >
			       	<tbody  >
			       		<tr>
			       			<td></td>
			       			<td></td>
			       			<td></td>
			       		</tr>
			       		<tr>
			       			<td>
			       				<div class="prev-btn" @click="prev()">
						          <span class="fa fa-chevron-left"></span>
						        </div>
						    </td>
			       			<td><i-loader :shown="!list[idx].loaded"/></td>
			       			<td style='text-align:right'>
						         <div class="next-btn" @click="next()">
						          <span class="fa fa-chevron-right"></span>
						        </div>
					    	</td>
			       		</tr>

			       		<tr>
			       			<td></td>
			       			<td style='vertical-align:bottom'>
						       	<div class="paginator">
						       		<div class="dots">
						       			<div class="dot" v-for="(p,i) in list" :class="{active:i===idx}" @click="idx=i"></div>
						       		</div>
						       	</div>
			       			</td>
			       			<td></td>
			       		</tr>
			       	</tbody>
			       </table>
				</div>
				<div class="image-description">{{list[idx].description}}</div>
			</div>
		</div>
	</div>
</template>

<script>
import iLoader from "./i-loader.vue"
export default {
  name: 'i-image-viewer',
  components:{iLoader},
  methods:{
  	focus(e){
  		console.log(e);
  		e.stopPropagation();
  		e.target.focus();
  	},
  	close(e){
  		this.$store.commit("closePhotoView");
  	},
  	exit(e){
  		if (e.target.classList[0] !== "fader") return;
  		this.$store.commit("closePhotoView");
		//this.opened = false; 
		//this.idx = -1;
  	},
  	prev(){
  		let {idx, list, $store:{dispatch}} = this;
  		if((idx-1)<0){
  			dispatch("openPhotoIdx",list.length-1);
  		} else dispatch("openPhotoIdx",this.idx-1);
  	},
  	next(){
  		let {idx, list, $store:{dispatch}} = this;
  		if((idx+1)>=list.length){
  			dispatch("openPhotoIdx",0);
  		} else dispatch("openPhotoIdx",this.idx+1);
  	}
  	//loadImage()
  },
  data () {
    return {
    	/*list:[{
	    	description:"IMAGE DESCRIPTION",
	    	title: "IMAGE TITLE",
	    	src:"http://www.intrawallpaper.com/static/images/Baltic_Sea_Wallpaper_By_Martz90_2560X1600_2_qeburq6.jpg"
    	}],
    	idx:0*/
    }
  },
  mounted(){
  	let self = this;
  	document.body.addEventListener('keyup',(e)=>{
  		if(self.opened){
	  		if(e.keyCode==37){
	  			self.prev();
	  		}
	  		if(e.keyCode==39){
	  			self.next();
	  		}
  		}
  	});

	this.$store.registerModule('imageViewer',{
	    state: {
	    	list:[],
	    	idx:0,
	    	opened:false,
	    	//loaded:false,
    		loadedImage:""
	    },
	    mutations: {
	    	closePhotoView(state){
	    		state.opened = false;
	    	},
	        openPhoto(state, photo) {
	    		state.list = photo.list;
	    		console.log(photo.index)
	    		state.idx = photo.index;
	    		state.opened = true;
	    		state.list[state.idx].loaded = true;
		  		let {src} = state.list[state.idx];
		  		state.loadedImage = src;
		    		
	        }
	    },
	    actions:{
	    	openPhotoIdx({commit,state,dispatch},idx){
	    		dispatch("openPhoto", {list:state.list, index:idx});
	    	},
	        openPhoto({commit,state}, photo) {
	    		state.list = photo.list;
	    		state.idx = photo.index;
	    		state.opened = true;

		    		
		  		let {src} = state.list[state.idx];
		  		console.log(src,this);
		  		if(state.list[state.idx].loaded){
		  			commit("openPhoto",{list:photo.list, index:photo.index});
		  		} else {
			  		//state.list[state.idx].loaded = false;
			  		state.loadedImage = "";
			  		let img = new Image();
			  		console.log(img)
			  		img.onload = ()=>{
			  			console.log("LOADED")
			  			state.loadedImage = src;
			  			state.list[state.idx].loaded = true;
			  			//state.loaded = true;
			  			img.remove();
			  		};
			  		img.src = src;
		  		}
				//document.body.appendChild(img);
	    		//self.$forceUpdate();
	        }
	    }
	});
  },
  computed:{
  	idx(){return this.$store.state.imageViewer.idx;},
  	list(){return this.$store.state.imageViewer.list;},
  	opened(){return this.$store.state.imageViewer?this.$store.state.imageViewer.opened:false;},
  	loadedImage(){return this.$store.state.imageViewer.loadedImage;},
  	loaded(){return this.$store.state.imageViewer.loaded;}
  }
}
</script>

<style lang="css" scoped>
.i-image-viewer .fader{
	position: fixed;
	background: rgba(0,0,0,0.5);
	width:100%;
	height:100%;
	top:0;
	left:0;
	z-index:1005;
	overflow: scroll;
	cursor: pointer;
}
.image-viewer-container{
	background: white;
	width:80%;
	top:10%;
	left:10%;
	position: absolute;
	border-radius: 4px;
	padding:6px;
	margin-bottom: 10%;
}

.image-box{
	background-color: #1e1e1e;
	background-size:contain;
	background-position: center;
	background-repeat: no-repeat;
	width:100%;

  min-height: 800px;
  min-height: 600px;


}
.image-box img{
	max-height: 500px;
}

.next-btn,.prev-btn{
  font-size:24px;
  color:grey;
  display: inline-block;
  cursor: pointer;
  border-radius: 100%;
  padding:8px 14px;
  vertical-align: middle;
}
.next-btn:hover,.prev-btn:hover{
	color:white;
	border:0 0 10px white;
}
.next-btn{
  margin-right: 10px;
}
.prev-btn{
	margin-left:10px;
}

.image-title{
	color:black;
	font-family: arial;
}

.paginator{
	text-align: center;
}
.paginator .dot{
	width:6px;
	height:6px;
	background: white;
	border-radius: 100%;
	display: inline-block;
	margin:5px;
}
.paginator .dot.active{
	box-shadow: 0px 0px 15px #00b8ff;
    background: #00b8ff;
}
.dots{
}

.image-box table{
	width: 100%;
	height:100%;
	min-height: 600px;
}
.exit-btn{
	position: absolute;
	right:-20px;
	top:-20px;
	font-size: 22px;
	color:white;
	cursor: pointer;
}
</style>